import { defineMessages } from 'react-intl'

export default defineMessages({
  name: 'freshcells systems engineering GmbH',
  address: 'Burghofstraße 40{br}40223 Düsseldorf{br}Germany'
})
